import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import "core-js/modules/es.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useContext } from 'react';
var LAYER_STEP = 500;

var LayeringContextValue = /*#__PURE__*/_createClass(function LayeringContextValue(baseZIndex, isInPortal) {
  var _this = this;

  _classCallCheck(this, LayeringContextValue);

  _defineProperty(this, "baseZIndex", void 0);

  _defineProperty(this, "isInPortal", void 0);

  _defineProperty(this, "popupZIndex", void 0);

  _defineProperty(this, "dropdownZIndex", void 0);

  _defineProperty(this, "tooltipZIndex", void 0);

  Object.defineProperty(this, 'baseZIndex', {
    writable: false,
    enumerable: true,
    value: baseZIndex
  });
  Object.defineProperty(this, 'isInPortal', {
    writable: false,
    enumerable: true,
    value: Boolean(isInPortal)
  });
  Object.defineProperty(this, 'popupZIndex', {
    enumerable: true,
    get: function get() {
      return _this.baseZIndex + 3 * LAYER_STEP;
    }
  });
  Object.defineProperty(this, 'dropdownZIndex', {
    enumerable: true,
    get: function get() {
      return _this.baseZIndex + 2 * LAYER_STEP;
    }
  });
  Object.defineProperty(this, 'tooltipZIndex', {
    enumerable: true,
    get: function get() {
      return _this.baseZIndex + LAYER_STEP;
    }
  });
});

var LayeringContext = /*#__PURE__*/createContext(new LayeringContextValue(0));
var LayeringConsumer = LayeringContext.Consumer;

var useLayeringContext = function useLayeringContext() {
  return useContext(LayeringContext);
};
/**
 * @deprecated use `useLayeringContext` hook instead
 * */


var withLayering = function withLayering(WrappedComponent) {
  var component = function component(props) {
    return /*#__PURE__*/React.createElement(LayeringContext.Consumer, null, function (layering) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, layering), props));
    });
  };

  component.displayName = "WithLayering(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return component;
};

export { LayeringConsumer, LayeringContext, LayeringContextValue, useLayeringContext, withLayering };
